export const firebaseConfig = {
  apiKey: "AIzaSyBEGX9WTsMtiSLklzK_c6IxYLQnS5Bd3W8",
  authDomain: "agentapp-6bab9.firebaseapp.com",
  projectId: "agentapp-6bab9",
  storageBucket: "agentapp-6bab9.firebasestorage.app",
  messagingSenderId: "335406622074",
  appId: "1:335406622074:web:becf4aa9acfb6e891422c3"
};

// VAPID key required for getToken()
export const VAPID_KEY = "BCW4xZedHoTkzdsoY7KM_HxEa4TRbKSynKzE1MuAWRvEZdFm9ECVXuqbync3b65b9DNQX_FQX7RldRVLX97YqEA";
